import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {AccountsService} from "../../../account/services/accounts-service.service";
import {ContractsDialogService} from "../../services/contracts-dialog-service.service";
import {ContractsService} from "../../services/contracts-service.service";
import {AccountReferenceModel} from "../../../account/models/account-reference.model";
import {SortType} from "../../../commons/types/sort.type";

export class ContractsTableViewCtrl implements IController {
  accountId: string;
  isAddMode?: boolean;
  onAdd?: Function;

  public queryString: string;
  public filtersConfig: any;
  public selectedIds: any;
  private infiniteScroll: any;
  private readonly loadLimit: number;
  private readonly contractsRef: any;
  public selectedSortValue: any;
  public sortTypesValues: any;

  public constructor(private $q, private $contracts, private $infiniteScroll, private contractsDialogService: ContractsDialogService,
                     private $log: ILogService, private contractsService: ContractsService, private $state, private accountsService: AccountsService) {
    this.loadLimit = 20;
    this.contractsRef = this.$contracts();
  }

  public $onInit() {
    this.filtersConfig = {
      queryString: undefined
    }
    this.selectedIds = {};
    this.sortTypesValues = {
      sortName: {asc: 'name,asc', desc: 'name,desc'},
      sortCreatedAt: {asc: 'createdAt,asc', desc: 'createdAt,desc'}
    };

    this.contractsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.contractsRef, this.loadLimit, {getFullData: true});

  }


  public onCreateContract(event) {
    this.contractsDialogService.createContract(event)
      .then((payload) => {
        return this.contractsService.createNewContract(payload.contractName, payload.settlementsArray, this.accountId)
      })
      .then((createdContract) => {
        this.$state.go('contract.details.service', {
          contractId: createdContract.id,
          programId: createdContract.entryList[0].id
        }, {notify: true});
      })
      .catch((error) => {
        this.$log.info('Failed to create new contract');
      })
  }

  public onAddContract(event) {
    this.contractsDialogService.addContract()
      .then((contract) => {
        return this.contractsService.assignAccounts(contract.id, {ids: [this.accountId]})
      })
      .then((createdContract) => {
        this._query();
      })
      .catch((error) => {
        this.$log.info('Failed to create new contract');
      })
  }

  onViewContract(contractId, programId) {
    this.$state.go('contract.details.service', {
      contractId: contractId,
      programId: programId
    }, {notify: true});

  }

  public onEditContractCarriers(contract) {

    const assignedAccountIds = _.map(_.get(contract, 'accountReferences'), (account: AccountReferenceModel) => {
      return account.id;
    })
    this.contractsDialogService.editContractCarriers(assignedAccountIds)
      .then((accountsLists: { accountIdsToAdd: string[], accountIdsToRemove: string[] }) => {
        this._updateCarriers(contract.id, accountsLists.accountIdsToAdd, accountsLists.accountIdsToRemove);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })
  }

  public onContractDelete(contract) {
    this.contractsService.deleteContract(contract.id)
      .then(() => {
        this.infiniteScroll.removeItems([contract]);
      })
  }

  public onUnlinkContract(accountId: string) {
    this.accountsService.removeContract(accountId)
      .then(account => {
        this.contractsRef.$query(this._getQueryPayload());
        this.infiniteScroll.reload()
      });
  }

  onSetContractAsDefault(contract) {
    this.contractsService.setAsDefault(contract.id)
      .then(() => {
        this.contractsRef.$query(this._getQueryPayload());
        this.infiniteScroll.reload()
      })
  }

  onQueryChanged(searchTerm) {
    this.filtersConfig.queryString = searchTerm;
    this._query();
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this._query();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _updateCarriers(contractId: string, carriersToAdd?: string[], carriersToRemove?: string[]) {
    let promises = [];
    if (carriersToAdd && carriersToAdd.length) {
      promises.push(this._assignAccountsToContract(contractId, carriersToAdd));
    }
    if (carriersToRemove && carriersToRemove.length) {
      promises.push(this._removeAccountsFromContract(contractId, carriersToRemove));
    }

    if (promises.length) {
      this.$q.all(promises)
        .finally(() => {
          this.contractsRef.$query(this._getQueryPayload());
          this.infiniteScroll.reload()
        })
    }
  }

  private _assignAccountsToContract(contractId: string, accountIds: string[]) {
    return this.contractsService.assignAccounts(contractId, {ids: accountIds})
  }

  private _removeAccountsFromContract(contractId: string, accountIds: string[]) {
    return this.contractsService.removeAccounts(contractId, accountIds)
  }

  private _getQueryPayload() {
    let payload = {
      query: this.filtersConfig.queryString,
      limit: this.loadLimit,
      sort: _.get(this.selectedSortValue, 'value')
    }
    if (this.accountId) {
      payload['accountIds'] = this.accountId
    }
    return payload;
  }

  private _query() {
    this.contractsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }
}

angular
  .module('bringoz.admin.contracts')
  .component('contractsTableView', {
    bindings: {
      accountId: '<?',
      isAddMode: '<?',
      onAdd: '&'
    },
    template: require('./contracts-table-view.html').default,
    controller: ContractsTableViewCtrl
  });
